/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 14/01/2014
 * Time: 13:51
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').
    factory('HumanResourceView',["HumanResourceData","HumanResourceSrv","HumanResource", "CompanyImageData",
        function (HumanResourceData,HumanResourceSrv,HumanResource, CompanyImageData) {

        var  HumanResourceView = function(humanResource,hrIndex,domainView,order) {
            this.hrIndex =  hrIndex;
            this.domainView = domainView;
            this.label = null;
            this.firstName = null;
            this.lastName = null;
            this.phone = null;
            this.email = null;
            this.description = null;
            this.gender = null;
            this.color = null;
            this.photo = null;
            this.photoId = null;
            this.hasPlanning = true;
            this.onLineBooking = true;
            this.order = null;
            this.display = true;
            this.hasPhoto = false;

            if (humanResource)
                this.loadDataFrom(humanResource);

            if(order != undefined && order != null) {
                this.order = order;
            }
        };

        HumanResourceView.prototype.loadDataFrom = function (humanResource) {
            if (humanResource.id) {
                this.id = humanResource.id;
            }
            this.label = humanResource.label;
            this.firstName = humanResource.firstName;
            this.lastName = humanResource.lastName;
            this.phone = humanResource.phone;
            this.email = humanResource.email;
            this.description = humanResource.description;
            this.gender = humanResource.gender;
            this.color = humanResource.color;
            this.photoId = humanResource.photoId;
            if (this.photoId) {
                this.photo = CompanyImageData.getById(this.photoId);
            }
            this.hasPhoto = this.photoId != null;
            this.hasPlanning = humanResource.hasPlanning;
            this.order = humanResource.order;
        };
        HumanResourceView.prototype.copyDataTo = function (humanResource) {
            humanResource.id = this.id;
            humanResource.label = this.label;
            humanResource.firstName = this.firstName;
            humanResource.lastName = this.lastName;
            humanResource.phone = this.phone;
            humanResource.email = this.email;
            humanResource.description = this.description;
            humanResource.gender = this.gender;
            humanResource.color = this.color;
            humanResource.photoId = this.photoId;
            humanResource.hasPlanning = this.hasPlanning;
            humanResource.onLineBooking = this.onLineBooking;
            humanResource.order = this.order;
        };
        HumanResourceView.prototype.isChanged = function () {
            let hr = this.getModel();
            if (hr)
                return (
                    this.label != hr.label ||
                    this.firstName != hr.firstName ||
                    this.lastName != hr.lastName ||
                    this.phone != hr.phone ||
                    this.email != hr.email ||
                    this.description != hr.description ||
                    this.gender != hr.gender ||
                    this.color != hr.color ||
                    this.photoId != hr.photoId ||
                    this.hasPlanning != hr.hasPlanning ||
                    this.onLineBooking != hr.onLineBooking ||
                    this.order != hr.order
                );
            else
                return true;

        };
        HumanResourceView.prototype.getModel = function () {
            if (this.hrIndex != -1)
                return HumanResourceData.getByIndex(this.hrIndex);
            return null;
        };

        HumanResourceView.prototype.initHrData = function () {
            let humanResource = this.getModel();
            if (humanResource == null) {
                humanResource = new HumanResource();
                this.hrIndex = HumanResourceData.getIndexOf(humanResource);
            }
            this.copyDataTo(humanResource);
            return humanResource;
        };

        HumanResourceView.prototype.updateModel = function () {
            if (!this.isChanged()) {
                let humanResourceView = this;
                let humanResource = this.initHrData();
                HumanResourceSrv.save(humanResource,
                        function() {
                            if (humanResource.id) {
                                humanResourceView.id = humanResource.id;
                            }
                        });
            }
        };

        HumanResourceView.prototype.updateModelWithPromise = function () {
            let humanResourceView = this;
            return new Promise((resolve, reject) => {
                if (!humanResourceView.isChanged()) {
                    return resolve();
                }
                let humanResource = humanResourceView.initHrData();
                HumanResourceSrv.save(humanResource,
                        function() {
                            if (humanResource.id) {
                                humanResourceView.id = humanResource.id;
                            }
                            return resolve();
                        }, reject);
            });
        };

        HumanResourceView.prototype.reloadModel = function () {
            let hr = this.getModel();
            if (hr != null)
                this.loadDataFrom(hr);
        };
        HumanResourceView.prototype.removeModel = function () {
            let hr = this.getModel();
            if (hr != null)
                HumanResourceSrv.remove(hr);
        };
        HumanResourceView.prototype.restoreModel = function () {
            let hr = this.getModel();
            if (hr)
                HumanResourceSrv.restore(hr);
        };

        HumanResourceView.prototype.knowsServiceView = function (serviceView) {
            if (serviceView) {
                let hr = this.getModel();
                if (hr) {
                    return hr.hasService(serviceView.getModel());
                }
            }
            return false;
        };
        HumanResourceView.prototype.canSave = function () {
            return this.firstName &&
                this.firstName != "" &&
                this.lastName &&
                this.lastName != "" &&
                this.label &&
                this.label != "" &&
                (this.hasPhoto && this.photoId != null
                || !this.hasPhoto && this.photoId == null) ;

        };

        HumanResourceView.prototype.setCompanyImage = function(photo) { //do not changed this method name, is used in companyImageCtrl.onUploadCompanyImageSuccess()
                this.photo = photo;
                this.photoId = photo ? photo.id : null;
        }

        return  HumanResourceView;
    }
    ]);




// WEBPACK FOOTER //
// ./js/services/views/HumanResourceView.js